<template>
  <div class="pc_bread-nav">
    <div class="nav-main">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">{{$t('PCBreadNav.index.646xgup6ugg0')}}</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/product' }" v-if="routeName != $t('router.selectModel')">{{$t('router.selectModel')}}</el-breadcrumb-item>
        <el-breadcrumb-item>{{ routeName }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PCBreadNav',
  props: {
    showBack: {
      type: Boolean,
      default: false
    },
    notInvite: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      routeName: this.$route.meta.title
    };
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    }
  },
  computed: {
    showBackData() {
      return this.showBack;
    },
    isNotInviteData() {
      return this.notInvite;
    }
  }
};

</script>

<style scoped lang="less">
.pc_bread-nav {
  margin: 24px 0;
  width: 100%;
  display: flex;
  justify-content: center;
  font-size: 14px;
  .nav-main {
    //width: 62.5%;
    width: 1680px;
    display: flex;
    .nav-back {
      font-size: 14px;
      color: #FF8A14;
      line-height: 1;
      margin-right: 20px;
      display: flex;
      align-items: center;
      cursor: pointer;
    }

    /deep/ .el-breadcrumb {
      line-height: 20px;
    }

    /deep/ .el-breadcrumb__inner {
      color: #252629;
      &.is-link {
        color: #8F949D;
        font-weight: 400;
        &:hover {
          color: #FF8A14;
        }
      }
    }
  }
}
</style>
